<mat-form-field
  color="primary"
  class="ccs-date {{ size }}"
  [hideRequiredMarker]="true"
  [floatLabel]="floatLabel">
  <mat-label>{{ label }}</mat-label>

  <input
    [disabled]="!!control.disabled"
    matInput
    [placeholder]="placeholder"
    [formControl]="control"
    [appCanAutoFocus]="autofocus"
    mask="00/00/0000"
    [showMaskTyped]="showMaskTyped"
    [dropSpecialCharacters]="dropSpecialCharacters"
    (focus)="onFocus.emit($event)"
    (blur)="onBlur.emit($event)" />

  <input
    [disabled]="!!control.disabled"
    style="display: none"
    matInput
    [min]="min"
    [max]="max"
    [matDatepicker]="picker"
    (dateChange)="onDatePickerChange($event)" />

  <mat-datepicker-toggle matSuffix [for]="picker" />
  <mat-datepicker
    #picker
    [startAt]="startAt"
    [startView]="startView"
    [touchUi]="touchUi"
    [xPosition]="xPosition"
    [yPosition]="yPosition"
    [restoreFocus]="restoreFocus"
    (viewChanged)="onViewChanged.emit($event)"
    (monthSelected)="onMonthSelected.emit($event)"
    (yearSelected)="onYearSelected.emit($event)"
    (opened)="onOpened.emit()"
    (closed)="onClosed.emit()" />

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }

  <mat-error>
    {{ control.errors | errorMessage: errorMessages }}
  </mat-error>
</mat-form-field>
